import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import React, { type FC, type JSX } from 'react';
import { type ReactConfirmProps, confirmable, createConfirmation } from 'react-confirm';
import { Button } from '../Inputs/Buttons';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import './NotifyDialog.scss';

interface NotifyDialogProps {
    title?: string | JSX.Element;
    message: string | JSX.Element;
    closeLabel?: string | JSX.Element;
}

const NotifyDialogComponent: FC<NotifyDialogProps & ReactConfirmProps> = (props) => {
    const { show, proceed, title, message, closeLabel } = props;
    const { t } = useTranslation('common');

    const handleClose = () => {
        proceed(true as any);
    };

    return (
        <Dialog 
            open={show} 
            className="notify_dialog"
            onClose={handleClose}
            disableEscapeKeyDown={false}
        >
            <DialogContent>
                <div className="notify_dialog_header">
                    <h2 className="notify_dialog_title">{title ?? t('notification')}</h2>
                    <Button 
                        variant="text" 
                        round 
                        className="notify_dialog_close_button" 
                        onClick={handleClose}
                    >
                        <CloseIcon/>
                    </Button>
                </div>
                <div className="notify_dialog_content">
                    {message}
                </div>
                <div className="notify_dialog_actions">
                    <Button 
                        variant='text'
                        onClick={handleClose}
                        autoFocus
                    >
                        {closeLabel ?? t('close')}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export const NotifyDialog = confirmable(NotifyDialogComponent);
export const notify: (props: NotifyDialogProps) => Promise<boolean> = createConfirmation(NotifyDialog) as any;